import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TextSection from "./TextSection";
import ImageSection from "./ImageSection";

const Section = ({content, link}) => {
  return (
    <>
      <Container>
        {content?.map((item, index) => (
          <Row key={index} className={index === 0 ? "py-3" : "py-5"}>
            {item?.position === "left" ? (
              <>
                <Col md="6" sm="12" xs="12">
                  <TextSection
                    position={item.position}
                    heading={item.heading}
                    info={item.info}
                    lists={item.lists}
                    buttonLink={link}
                  />
                </Col>
                <Col md="6" sm="12" xs="12">
                  <ImageSection
                    position={item.position}
                    heading={item.heading}
                    image={item.image}
                  />
                </Col>
              </>
            ) : (
              <>
                <Col md="6" sm="12" xs="12">
                  <ImageSection
                    position={item.position}
                    heading={item.heading}
                    image={item.image}
                  />
                </Col>
                <Col md="6" sm="12" xs="12">
                  <TextSection
                    position={item.position}
                    heading={item.heading}
                    info={item.info}
                    lists={item.lists}
                    buttonLink={link}
                  />
                </Col>
              </>
            )}
          </Row>
        ))}
        {/* <GetStartedSection
          heading="Transform Your Testing Lifecycle with GAINSS"
          subheading="Experience the power of AI, automation, and intelligent insights to
            drive quality and efficiency across your testing lifecycle."
        /> */}
      </Container>
    </>
  );
};

export default Section;
